document.addEventListener('DOMContentLoaded', (event) => {
  const categoryCheckboxes = document.querySelectorAll(
    '.display-formations__filter input[type="checkbox"]'
  );
  const softwareCheckboxes = document.querySelectorAll(
    '.display-formations__logiciels input[type="checkbox"]'
  );
  const allCheckbox = document.querySelector(
    '.display-formations__filter input[value="all"]'
  );
  const formations = document.querySelectorAll('.display-formations__item');
  const updateFormationsDisplay = () => {
    const checkedCategorySlugs = [...categoryCheckboxes]
      .filter((checkbox) => checkbox.checked && checkbox !== allCheckbox)
      .map((checkbox) => checkbox.value);
    const checkedSoftwareSlugs = [...softwareCheckboxes]
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  

    formations.forEach((formation) => {
      const formationSlugs = formation.dataset.categories
        .split(' ')
        .filter((slug) => slug);
  
      const isCategoryMatch = checkedCategorySlugs.length === 0 ||
        checkedCategorySlugs.some((slug) => formationSlugs.includes(slug));
  
      const isSoftwareMatch = checkedSoftwareSlugs.length === 0 ||
        checkedSoftwareSlugs.some((slug) => formationSlugs.includes(slug));
  
      if (isCategoryMatch && isSoftwareMatch) {
        formation.style.display = 'flex';
      } else {
        formation.style.display = 'none';
      }
    });
  
    if (checkedCategorySlugs.length === 0) {
      allCheckbox.checked = true;
    }
  };  
 /* const updateFormationsDisplay = () => {
    const checkedCategorySlugs = [...categoryCheckboxes]
      .filter((checkbox) => checkbox.checked && checkbox !== allCheckbox)
      .map((checkbox) => checkbox.value);
    const checkedSoftwareSlugs = [...softwareCheckboxes]
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    formations.forEach((formation) => {
      const formationSlugs = formation.dataset.categories
        .split(' ')
        .filter((slug) => slug);
      const isCategoryMatch =
        checkedCategorySlugs.length === 0 ||
        checkedCategorySlugs.every((slug) => formationSlugs.includes(slug));
      const isSoftwareMatch =
        checkedSoftwareSlugs.length === 0 ||
        checkedSoftwareSlugs.every((slug) => formationSlugs.includes(slug));

      if (isCategoryMatch && isSoftwareMatch) {
        formation.style.display = 'flex';
      } else {
        formation.style.display = 'none';
      }
    });

    if (checkedCategorySlugs.length === 0) {
      allCheckbox.checked = true;
    }
  };*/

  categoryCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      if (checkbox === allCheckbox && allCheckbox.checked) {
        formations.forEach((formation) => (formation.style.display = 'flex'));
        categoryCheckboxes.forEach((cb) => {
          if (cb !== allCheckbox) cb.checked = false;
        });
      } else {
        allCheckbox.checked = false;
        updateFormationsDisplay();
      }
    });
  });

  softwareCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateFormationsDisplay);
  });

  allCheckbox.addEventListener('click', (event) => {
    if (!allCheckbox.checked) {
      event.preventDefault();
    }
  });
});
